<div class="request-account-container">
  <h2 class="text-center text-white mb-4">Inpress</h2>
  <div class="col-md-6 mx-auto">
    <a class="small login-link" routerLink="/login">
      <mat-icon>keyboard_arrow_left</mat-icon>
      <span>Terug naar login</span>
    </a>
    <div class="card rounded-0 pl-0 pr-0">
      <div class="card-header">
        <h3>Login aanvraag</h3>
      </div>
      <div [formGroup]="requestAccountForm" class="card-body pl-0 pr-0">
        <div class="d-flex">
          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Voornaam</mat-label>
            <input
              matInput
              type="text"
              required
              formControlName="firstName"
              [placeholder]="'Voornaam'"
            />
            <mat-error
              *ngIf="requestAccountForm.controls.firstName.errors?.required"
            >
              Voornaam is vereist
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Achternaam</mat-label>
            <input
              matInput
              type="text"
              required
              formControlName="lastName"
              [placeholder]="'Achternaam'"
            />
            <mat-error
              *ngIf="requestAccountForm.controls.lastName.errors?.required"
            >
              Achternaam is vereist
            </mat-error>
          </mat-form-field>
        </div>

        <div class="d-flex">
          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Gsm</mat-label>
            <input
              matInput
              type="text"
              required
              formControlName="mobilePhoneNumber"
              [placeholder]="'GSM'"
            />
            <mat-error
              *ngIf="
                requestAccountForm.controls.mobilePhoneNumber.errors?.required
              "
            >
              Gsm-nummer is vereist
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Bedrijf</mat-label>
            <input
              matInput
              type="text"
              required
              formControlName="companyName"
              [placeholder]="'Bedrijf'"
            />
            <mat-error
              *ngIf="requestAccountForm.controls.companyName.errors?.required"
            >
              Bedrijfsnaam is vereist
            </mat-error>
          </mat-form-field>
        </div>
        <div class="d-flex">
          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Email</mat-label>
            <input
              matInput
              type="text"
              required
              formControlName="email"
              [placeholder]="'Email'"
            />
            <mat-error
              *ngIf="requestAccountForm.controls.email.errors?.required"
            >
              Email is vereist
            </mat-error>
            <mat-error *ngIf="requestAccountForm.controls.email.errors?.email">
              Geldig e-mailadres is vereist
            </mat-error>
          </mat-form-field>
        </div>
        <div class="d-flex justify-content-end pl-3 pr-3">
          <button
            type="submit"
            class="btn btn-success btn-lg"
            (click)="submit()"
          >
            Login aanvragen
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
